// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-link[data-v-9a3a9c18]{cursor:pointer}.el-icon-s-operation[data-v-9a3a9c18]{font-size:24px}.el-card[data-v-9a3a9c18]{padding:0 0;border:none}", ""]);
// Exports
module.exports = exports;
